import withEditarHonorarios from "../../hoc/withTrabajadores/withEditarHonorarios";
import EditarHonorarios from "../../view/components/RegistroUsuarios/Honorarios/EditarHonorarios";

export default withEditarHonorarios(EditarHonorarios);